import React from 'react';
import { PropTypes } from 'prop-types';
import * as S from './styles';
import MatchTeam from '../MatchTeam';

export default function TeamBlock({
  className,
  isLocal,
  bgImage,
  lineUp,
  selectedMatch,
}) {
  const squadHome = lineUp.homeTeamLineUp
    ? lineUp.homeTeamLineUp.startPlayers
    : [];
  const trainerHome = lineUp.homeTeamLineUp
    ? lineUp.homeTeamLineUp.trainer
    : {};
  const formationHome = lineUp.homeTeamLineUp
    ? lineUp.homeTeamLineUp.playersFormation
    : [];

  const squadAway = lineUp.awayTeamLineUp
    ? lineUp.awayTeamLineUp.startPlayers
    : [];
  const trainerAway = lineUp.awayTeamLineUp
    ? lineUp.awayTeamLineUp.trainer
    : {};
  const formationAway = lineUp.awayTeamLineUp
    ? lineUp.awayTeamLineUp.playersFormation
    : [];

  return (
    <S.Container className={className} isLocal={isLocal} bgImage={bgImage}>
      {selectedMatch && (
        <MatchTeam
          team={isLocal ? selectedMatch.homeTeam : selectedMatch.awayTeam}
          squad={isLocal ? squadHome : squadAway}
          trainer={isLocal ? trainerHome : trainerAway}
          formation={isLocal ? formationHome : formationAway}
          isLocal={isLocal}
        />
      )}
    </S.Container>
  );
}

TeamBlock.propTypes = {
  className: PropTypes.string,
  isLocal: PropTypes.bool,
  bgImage: PropTypes.string,
  lineUp: PropTypes.object,
  selectedMatch: PropTypes.object,
};

TeamBlock.defaultProps = {
  className: null,
  isLocal: false,
  bgImage: null,
  lineUp: {},
  selectedMatch: {},
};
